import {useAppDispatch, useAppSelector} from './useReduxHooks'
import * as actions from '../redux/reducers/establishements/service'
import {
  ActivateEstablishementRequest,
  CreateEstablishementRequest,
  DeleteEstablishementRequest,
  FetchAllEstablishementsRequest,
  FetchEstablishementByIdRequest,
  FetchEstablishementsRequest,
  SuspendEstablishementRequest,
  UpdateEstablishementRequest,
} from '../redux/reducers/establishements/types'

export default function useEstablishements() {
  const dispatch = useAppDispatch()
  const {
    establishements,
    establishementForEdit,
    listLoading,
    actionLoading,
    error,
    total,
    totalPages,
  } = useAppSelector((state) => state.establishments)

  const fetchEstablishements = (props: FetchEstablishementsRequest) => {
    return dispatch(actions.fetchEstablishements(props))
  }

  const fetchAllEstablishements = (props: FetchAllEstablishementsRequest) => {
    return dispatch(actions.fetchAllEstablishements(props))
  }

  const fetchEstablishementById = (props: FetchEstablishementByIdRequest) => {
    return dispatch(actions.fetchEstablishementById(props))
  }

  const createEstablishement = (props: CreateEstablishementRequest) => {
    return dispatch(actions.createEstablishement(props))
  }

  const updateEstablishement = (props: UpdateEstablishementRequest) => {
    return dispatch(actions.updateEstablishement(props))
  }

  const deleteEstablishement = (props: DeleteEstablishementRequest) => {
    return dispatch(actions.deleteEstablishement(props))
  }

  const suspendEstablishement = (props: SuspendEstablishementRequest) => {
    return dispatch(actions.suspendEstablishement(props))
  }

  const activateEstablishement = (props: ActivateEstablishementRequest) => {
    return dispatch(actions.activateEstablishement(props))
  }

  return {
    fetchAllEstablishements,
    establishementForEdit,
    establishements,
    listLoading,
    actionLoading,
    error,
    fetchEstablishements,
    fetchEstablishementById,
    createEstablishement,
    updateEstablishement,
    deleteEstablishement,
    suspendEstablishement,
    activateEstablishement,
    total,
    totalPages,
  }
}
